import { createGenericSlice, DjangoModel } from '@store/slices/generic.slice'
import { RootState } from '@store/store'

export const audioUrl = 'audio'

export interface AudioModel extends DjangoModel {
  publicPath: string
  name: string
  length: string
}

const {
  slice: audioSlice,
  thunks: audioThunks,
  adapter: audioAdapter,
  selectors,
} = createGenericSlice<AudioModel>(
  'audio',
  audioUrl,
  {}
  //audioExtraReducers  Initial state can be customized if needed
)

// export const audioAdapterExport = audioAdapter

export const { fetchAll: fetchAllAudios, fetchById: fetchAudioById } =
  audioThunks

export const { selectAll: selectAllAudios, selectById: selectAudioById } =
  audioAdapter.getSelectors<RootState>((state: RootState) => state.audio)

export const {
  selectLoading: selectAudioLoading,
  selectIsIdInProgress: selectIsAudioIdInProgress,
  selectError: selectAudioError,
} = selectors

export default audioSlice.reducer
